export const emailDomainOptions = [
	{ label: "구글", value: "gmail.com" },
	{ label: "네이버", value: "naver.com" },
	{ label: "다음", value: "daum.net" },
	{ label: "카카오", value: "kakao.com" },
	{ label: "직접입력", value: "custom" },
	// ...기타 옵션 추가 가능
];
